'use strict';

import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {States} from '@uw-it-sis/lib-react/lib/AppConstants';
import {observer} from "mobx-react";

import Broken from "@uw-it-sis/lib-react/lib/Broken";
import UnknownState from "@uw-it-sis/lib-react/lib/UnknownState";

import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Alert from 'react-bootstrap/Alert';
import Loading from '@uw-it-sis/lib-react/lib/Loading';

import courseSyllabusStore from './CourseSyllabusStore'

class CourseSyllabus extends Component {

    constructor(props) {
        super(props);
        this.props = props;

        this.state = {
           showModal: false
        };

        this.store = courseSyllabusStore;

        this.showModal = this.showModal.bind(this);
        this.hideModal = this.hideModal.bind(this);
    }

    showModal = () => {
        this.setState({showModal: true});
        var sectionId = this.props.section.activityId;
        this.store.loadSyllabus(sectionId);
    };

    hideModal = () => {
        this.setState({showModal: false});
    };

    render() {
        let section = this.props.section;

        let syllabusModalBody = null;

        switch (this.store.state) {
            case States.pending:
               syllabusModalBody = <Loading type="dots" alt={'Loading Course Syllabus...'}/>;
               break;
            case States.error:
                syllabusModalBody = <Broken name="CourseSyllabus"/>;
                break;
            case States.done:
                let syllabus = courseSyllabusStore.getSyllabus(section.activityId);
                let htmlSyllabus = document.createElement('div');
                htmlSyllabus.innerHTML = syllabus;
                let links = htmlSyllabus.getElementsByTagName('a');
                for (let i = 0; i < links.length; i++) {
                    links[i].setAttribute('target', '_blank');
                }
                syllabusModalBody =
                    <div className="cdpCourseSyllabus" dangerouslySetInnerHTML={{ __html: htmlSyllabus.outerHTML }}></div>

            case States.initial:
                break;
            default:
                 syllabusModalBody = <UnknownState name="CourseSyllabus"/>;

        }

        return (
            <div>
                <Button variant="inline-link" onClick={this.showModal} aria-haspopup="true">View syllabus</Button>
                <Modal id="modal-syllabus"
                       show={this.state.showModal}
                       onHide={this.hideModal}
                       size="lg"
                       aria-labelledby="modal-syllabus-title"
                       centered>
                    <Modal.Header closeButton>
                        <Modal.Title id="modal-syllabus-title">Course Syllabus - {section.courseCode} {section.code}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {syllabusModalBody}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="primary" onClick={this.hideModal}>Close</Button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}

CourseSyllabus.propTypes = {
    section: PropTypes.object.isRequired
};

export default observer(CourseSyllabus);